type AuthMode = 'cognito' | 'mock';

const allowedModes = new Set<AuthMode>(['cognito', 'mock']);
const requestedModeRaw = String(import.meta.env.VITE_AUTH_MODE ?? 'cognito').toLowerCase();

const requestedMode: AuthMode = allowedModes.has(requestedModeRaw as AuthMode)
  ? (requestedModeRaw as AuthMode)
  : 'cognito';

const envName = String(import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE ?? '').toLowerCase();
const hostname =
  typeof window !== 'undefined' ? String(window.location.hostname || '').toLowerCase() : '';
const isHostLocal =
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname === '::1' ||
  hostname.endsWith('.local');
const isEnvLocal = envName === 'local';

// Runtime safety: mock auth can only activate on local runtime.
export const isLocalRuntime = Boolean(import.meta.env.DEV) || isHostLocal || isEnvLocal;
export const isMockAuthEnabled = requestedMode === 'mock' && isLocalRuntime;
export const effectiveAuthMode: AuthMode = isMockAuthEnabled ? 'mock' : 'cognito';
export const configuredAuthMode: AuthMode = requestedMode;

if (requestedModeRaw !== requestedMode) {
  console.warn(
    `[AUTH_MODE] Invalid VITE_AUTH_MODE="${requestedModeRaw}". Falling back to "${effectiveAuthMode}".`,
  );
}

if (requestedMode === 'mock' && !isMockAuthEnabled) {
  console.warn(
    `[AUTH_MODE] VITE_AUTH_MODE=mock is allowed only on local runtime. Falling back to "${effectiveAuthMode}".`,
  );
}
